import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { ServiceWalkInService } from '../../../services/index';

@Component({
	selector: 'add-drop-reason-window',
	templateUrl: './addDropReason.component.html'
})
export class AddDropReasonComponent implements OnInit {
	public title: string;
	public mode: string;
	public list: any[] = [];
	public dropdata: any[] = [];

	// trigger-variable for Ladda
	isLoading: boolean = false;
	@Output() branchLoadEvent = new EventEmitter();

	constructor(private serviceWalkInService: ServiceWalkInService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

	}

	ngOnInit(): void {
		setTimeout(() => {
		    $('#company_name').focus();
		}, 100);
	}
	onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
	onSaveDrop(): void {

		let that = this;
		this.isLoading = true;
		this.serviceWalkInService
			.deleteServiceWalkIn(this.dropdata)
			.then(function(res: any) {
				that.isLoading = false;
				if (res.success){
					swal('SUCCESS', res.message, 'success');
					that.bsModalRef.hide();
					that.branchLoadEvent.emit();
				}else{
					var toast = {
				      type: 'error',
				      title: 'ERROR',
				      body: res.message
				    };
				    that.toasterService.pop(toast);
				}

			});
	}
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addDropReason.component.ts